export enum ActionButtonAppearance {
  GHOST = 'ghost',
  FILLED = 'filled',
}
